export { default } from "./ClickabilityTab";
